/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_FailedInputs */

const en_us2_share_failed = /** @type {(inputs: Share_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't share right now.`)
};

const pt_br2_share_failed = /** @type {(inputs: Share_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu para compartilhar agora.`)
};

const es_419_share_failed = /** @type {(inputs: Share_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo compartir ahora.`)
};

const pt_pt2_share_failed = /** @type {(inputs: Share_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível partilhar agora.`)
};

const fr_fr2_share_failed = /** @type {(inputs: Share_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de partager pour le moment.`)
};

const de_de2_share_failed = /** @type {(inputs: Share_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilen ist gerade nicht möglich.`)
};

const it_it2_share_failed = /** @type {(inputs: Share_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile condividere adesso.`)
};

/**
* | output |
* | --- |
* | "Couldn't share right now." |
*
* @param {Share_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_failed = /** @type {((inputs?: Share_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_failed(inputs)
	if (locale === "es-419") return es_419_share_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_share_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_share_failed(inputs)
	if (locale === "de-DE") return de_de2_share_failed(inputs)
	if (locale === "it-IT") return it_it2_share_failed(inputs)
	return en_us2_share_failed(inputs)
});
export { share_failed as "share.failed" }